export const PRICING_TABLE_HEAD_COLUMN_TEST_ID = {
  tag: 'pricing-table-head-column-tag',
  image: 'image',
  title: 'title',
  description: 'description',
};
